const IMAGE_URL_RE = /^https?:\/\/.+\.(jpe?g|png|gif|webp|bmp|avif|svg)(\?.*)?$/i;
const YOUTUBE_RE =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})(?:[?&].*)?$/i;

export function hasMedia(text: string): boolean {
  return text.split('\n').some((line) => {
    const t = line.trim();
    return IMAGE_URL_RE.test(t) || YOUTUBE_RE.test(t);
  });
}

export default function CommentBody({ text }: { text: string }) {
  return (
    <div>
      {text.split('\n').map((line, i) => {
        const trimmed = line.trim();
        const ytMatch = trimmed.match(YOUTUBE_RE);
        if (ytMatch) {
          return (
            <div key={i} className="mt-2 aspect-video w-full max-w-lg">
              <iframe
                src={`https://www.youtube.com/embed/${ytMatch[1]}`}
                title="YouTube video"
                className="h-full w-full rounded-lg"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </div>
          );
        }
        if (IMAGE_URL_RE.test(trimmed)) {
          return (
            <img
              key={i}
              src={trimmed}
              alt=""
              className="mt-2 max-w-sm rounded-lg object-contain"
              loading="lazy"
            />
          );
        }
        return line ? (
          <p key={i} className="text-sm text-gray-700">
            {line}
          </p>
        ) : (
          <br key={i} />
        );
      })}
    </div>
  );
}
